import type { AiExecutionStep } from '../../types/aiOperational'
import { ExecutionAuthorityPill } from './ExecutionAuthorityPill'

export const ExecutionStepCard = ({ step }: { step: AiExecutionStep }) => (
  <article className={`aiExecutionStepCard aiExecutionStepCard--${step.state.toLowerCase()}`}>
    <div>
      <strong>{step.title}</strong>
      <span>{step.state.toLowerCase()}</span>
    </div>
    <p>{step.description}</p>
    <footer>
      <ExecutionAuthorityPill authority={step.authority} />
      {step.requiresUserAction ? <span>User action</span> : null}
      {step.dependencyIds.length ? <span>{step.dependencyIds.length} dependencies</span> : null}
      {step.checkpointIds.length ? <span>{step.checkpointIds.length} checkpoints</span> : null}
    </footer>
  </article>
)
